import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <CarouselSection />
        <AppSection />
        <MediaSection />
        <TopicsSection />
        <AboutSection />
        <IndexSection />
        <ContactSection />
        <CardsSection />
        <CommentsSection />
        <FeaturesSection />
        <UpdatesSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}